import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';
var Config = require('../../../config');

class ModalFingerprint extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveFingerprint = this.saveFingerprint.bind(this);
		this.state = {
		    show: false,
		    image:"",
		    showSaveBtn:false,
		    flagStart:false,
		    count:0,
		    flagFinished:false,
		    flagRepeat:false,
		    fmd:"",
		    disableStartBtn:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, donor_id:""});
		//this.props.socket.close();
	}

	handleShow(image) {
		if(image === ""){
			this.setState({ show: true,image:"",showSaveBtn:false,count:0,flagStart:false,flagFinished:false });
		}else{
			this.setState({ show: true,image:image,showSaveBtn:false, flagStart:true, flagFinished:true});
		}

		this.props.socket.onerror = (event)=> {
			this.setState({disableStartBtn:true});
		};

		this.props.socket.onopen = (event)=> {
		   this.props.socket.send("initfp");
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if (res.Huella){
		        this.setState({ image:res.Huella,count:this.state.count+1,flagRepeat:true });
			}
			
		    if (res.Error){
		    	if(res.Error === "No hay lector inicializado"){
		    		swal('Error', "No hay lector inicializado. Por favor verifique la conexión de su dispositivo y refresque la página", 'error');
		    	}else{
		        	swal('Error', res.Error, 'error');
		    	}
		    	this.setState({ image:"",count:0,flagStart:false, flagFinished:false,flagRepeat:false });
		    }

		    if (res.Mensaje)
		        console.log(res.Mensaje);

		    if (res.Fmd) {
		    	this.setState({ showSaveBtn: true,flagFinished:true,flagRepeat:false,fmd:res.Fmd});
		    }
		}
	}

	startRead = ()=>{
		try{
			this.props.socket.send("FPReset");
			this.props.socket.send('enrol');
			this.setState({ image: "", flagStart:true});		
		}catch(error){
			console.log(error);
			swal('Error', 'Lector de huella no identificado','error');
		}
	}

	saveFingerprint(){
		if(this.state.fmd.length > 0){
			this.setState({ show: false});
			//Si ya esta registrado el donante en la BD
			if(this.props.state.donor_id !== ""){//Actualizar directamente la huella en BD
				var obj = {};
				obj.data = this.state.fmd;
				var aux = this.state.image.split(',');
				obj.image = aux[1];
				fetch(Config.default.apiGateway.URL+'donors/update_fingerprint?donor_id='+this.props.state.donor_id+'&option=',{ 
			        method: 'post',
			        body: JSON.stringify(obj), // data can be `string` or {object}!
			        headers: new Headers({
			           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			           'Accept': 'application/json',
			            'Content-Type': 'application/json',
			        })
			    })
			    .then(res => {
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(result) {
		                swal('¡Error!', result, 'error');
		              });
		            }})
		        .then(response => {
		        	if(response !== undefined){
		        		console.log(response);
				    }
			    })
			}
			this.props.save(this.state.image,this.state.fmd);
		}else{
			swal('Error', 'No se ha realizado la lectura de ninguna huella','error');
		}
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_fingerprint.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			{this.state.flagStart?
		        				<div>
		        					{this.state.flagFinished?
		        						<div style={{textAlign:"center",align:"center"}}>
		        							<div className="status-bar col-xs-offset-3 col-xs-6" style={{backgroundColor:"green",marginBottom:"15px", textAlign:"center"}} >
								            	<label style={{color:"white"}}>LECTURA TERMINADA</label>
								            </div>
		        						</div>
		        					:<div>
				        				<div>
				        					{this.state.flagRepeat?
				        						<div className="status-bar col-xs-offset-3 col-xs-6" style={{backgroundColor:"orange",marginBottom:"15px", textAlign:"center"}} >
								            		<label style={{color:"white"}}>VOLVER A COLOCAR</label>
								            	</div>
				        					:<label>COLOQUE SU HUELLA</label>}
				        				</div>
			        				</div>}
		        				</div>
		        			:null}
		        			{!this.state.flagFinished&&!this.state.flagStart?
			        			<RaisedButton label="Iniciar Lectura" primary={true} onClick={this.startRead} style={{float:"right"}} disabled={this.state.disableStartBtn}/>
			        		:null}
			        	</div>
		        		{this.state.image.length>0?
		        			<div className="form-group col-xs-12">
				        		{/*<h4 style={{textAlign:"center",paddingLeft:"30px",textDecoration: "underline"}}>{t('content.modal_fingerprint.preview')}</h4>*/}
				        		<div className="col-xs-12" style={{textAlign:"center"}}>
						        	<img alt="" src={this.state.image} style={{width:"234px",height:"175px"}}/>
						        </div>
					        </div>
					     :null}
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{this.state.showSaveBtn?<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveFingerprint}/>
		        	:null}
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalFingerprint);